import {useMutation} from '@apollo/client'
import React, {useEffect} from 'react'
import {Alert, Button, Modal, Spinner} from 'react-bootstrap'
import {DELETE_PIPELINE} from '../../../gql/mutations/pipelineMutations'
import {IResDeletePipe} from '../../../types/pipelines'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'

interface IModalDeletePipeline {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit: {id: string; name: string}
}

export const ModalDeletePipeline: React.FC<IModalDeletePipeline> = ({
  infoEdit,
  isOpen,
  onClose,
  refetch,
}) => {
  const [gqlAddEditPipeline, {data, loading, error}] = useMutation<IResDeletePipe>(DELETE_PIPELINE)

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.deletePipeline?.success) {
      toast.success(`Success: Delete pipeline successfully`)
      onClose()
      refetch()
    } else if (data.deletePipeline?.errors?.length > 0) {
      toast.error(`Error: ${data.deletePipeline?.errors?.[0]?.message || 'something happened'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlAddEditPipeline({
      variables: {
        pipelineId: parseId(infoEdit.id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Pipeline</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant='warning' className='my-4 '>
          <Alert.Heading className='d-flex align-items-center gap-2'>
            <i className='bi bi-exclamation-circle fs-3' style={{color: 'inherit'}} />
            Important
          </Alert.Heading>
          <p>This pipeline will not be deleted if it has associated Leads.</p>
        </Alert>
        <h2 className='text-danger'>
          Are you sure you want to delete this pipeline "
          <span className='text-primary'>{infoEdit.name}</span>"?
        </h2>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='danger'
          className='d-flex align-items-center'
          disabled={loading}
          onClick={handleDelete}
        >
          {loading && <Spinner animation='border' size='sm' />}
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
